<template>
  <div class="matched">
    <p v-if="isEmptyResult">Услуги не найдены</p>
    <div v-else class="matched__items">
      <div
        v-for="(value, name) in matchedServicesGroupedByCategories"
        v-bind:key="name"
      >
        <p class="matched__label">{{ name }}</p>
        <div
          class="matched__item"
          v-bind:class="{
            'no-price-name': !showPriceName,
            selected: isSelected(service),
          }"
          v-for="{ service } in value"
          v-bind:key="service.id"
        >
          <p>{{service.clinic_code}}</p>
          <button
            class="matched__item__button"
            type="button"
            v-on:click="onSelectMatchedService(service, $event)"
          >
            <span>{{ service.name }}</span>
          </button>
          <button
            v-if="showPriceName"
            class="matched__item__button"
            type="button"
            v-on:click="onSelectMatchedService(service, $event)">
            <span>{{ service.priceName }}</span>
          </button>
          <the-rub
            class="matched__item__price"
            v-bind:show-kop="$options.SHOW_KOP_AUTO"
            v-bind:kop="service.cost"
            currency="тнг" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheRub, { SHOW_KOP_AUTO } from '@/components/TheRub.vue';

/**
 * @description Список подходящих услуг.
 * @type {Vue}
 */
export default {
  components: {
    TheRub,
  },
  SHOW_KOP_AUTO,
  computed: {
    /**
     * @description Результатов нет.
     * @returns {boolean}
     */
    isEmptyResult() {
      return (
        this.value
        && this.isAwaitLoadingMatchedServices === false
        && this.matchedServiceList.length === 0
        && this.searchInputViolations.length === 0
      );
    },
    /**
     * @description Подходящие услуги.
     * @returns {Object[]}
     */
    matchedServices() {
      return this.matchedServiceList.map((service) => ({
        service,
        isSelected: this.selectedServices.contains(service),
      }));
    },
    /**
     * @description Подходящие услуги сгруппированные по категориям.
     * @returns {Object[]}
     */
    matchedServicesGroupedByCategories() {
      return this.matchedServiceList.map((service) => ({
        service,
        isSelected: this.selectedServices.contains(service),
      }))
        .reduce((acc, item) => {
          const groupName = item.service.categoryName || 'Прочие';
          if (Object.prototype.hasOwnProperty.call(acc, groupName) !== true) {
            acc[groupName] = [];
          }
          acc[groupName].push(item);
          return acc;
        }, {});
    },
  },
  methods: {
    /**
     * @description Обработать выбор услуги из списка подходящих.
     * @type {Object}  service Услуга.
     * @type {boolean} value   Выбрана.
     * @returns {void}
     */
    onSelectMatchedService(service) {
      this.$emit('select-service', service);
    },
    /**
     * @description Изменить цвет выбранной услуги на синий.
     * @param {Object} evt     Событие.
     * @returns {void}
     */
    onSelectSetColor(evt) {
      const currentService = evt.target;
      if (currentService.parentNode.parentNode.classList.contains('selected')) {
        currentService.parentNode.parentNode.classList.remove('selected');
      } else {
        currentService.parentNode.parentNode.classList.add('selected');
      }
      if (currentService.classList.contains('selected')) {
        currentService.classList.remove('selected');
      } else {
        currentService.classList.add('selected');
      }
    },
    /**
     * @description Является ли услуга выбранной.
     * @type {Object}  service Услуга.
     * @returns {boolean}
     */
    isSelected(service) {
      return this.selectedServicesIds.includes(service.id);
    },
  },
  name: 'MatchedServiceList',
  props: {
    /**
     * @description Подходящие услуги.
     * @type {Array}
     */
    matchedServiceList: { required: true, type: Array },
    /**
     * @description Выбранные услуги.
     * @type {Object}
     */
    selectedServices: { required: true, type: Object },
    /**
     * @description Показывать наименование прайса.
     * @type {Boolean}
     */
    showPriceName: { default: () => true, type: Boolean },
    /**
     * @description Список выбранных услуг.
     * @type {any[]}
     */
    selectedServicesIds: { default: () => [], type: Array },
  },
};
</script>

<style scoped lang="scss">

.matched {
  width: 100%;
  margin-bottom: 15px;
  &__items {
    display: grid;
    row-gap: 10px;
    padding: 0;
    list-style: none;
    ul {
      padding-inline: 24px;
    }
  }

  &__label {
    list-style: none;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 4px;
    margin-left: 135px;
  }

  &__item {
    display: grid;
    grid-template-columns: 125px auto 200px 100px;
    column-gap: 10px;
    &.selected {
      color: #029bff;
      font-weight: 600;
    }
    &:not(:last-of-type) {
      margin-bottom: 10px;
    }
    @media (hover: hover) {
      &:hover {
        color: #029bff;
      }
    }
    @media screen and (min-width: 481px) {
      &.no-price-name {
        grid-template-columns: 125px 1fr 100px;
      }
    }
    &__button {
      max-width: 400px;
      text-align: left;
      align-content: start;
      span {
        display: inline-block;
        height: 100%;
      }
      &:active {
        color: #029bff;
      }
    }
    &__price {
      text-align: right;
    }
  }
}

@media screen and (max-width: 480px) {
  .matched {
    &__items {
      gap: 5px;
    }
    &__label {
      margin-bottom: 4px !important;
      margin-left: 0;
    }
    &__item {
      grid-template: auto 2fr / 1fr;
      border-bottom: 1px solid rgba(144, 160, 183, 0.7);
      gap: 4px;
      &:last-child {
        border-bottom: none;
      }
      &.selected {
        background: #eaeff3;
      }
    }
  }
}
</style>
